import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-help-bottom',
  templateUrl: 'help-bottom.html',
})
export class HelpBottomPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {

  }

  openHelp() {
    if (this.globals.connection) {
      //this.navCtrl.push(HelpPage);
      window.open('https://mycheftool.zendesk.com/hc/es', '_blank');
    } else {
      this.globals.launchToastNoConnection();
    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/components/help-bottom/help-bottom.ts